<template>
  <i-container class="_align-self:stretch _display:flex _justify-content:center _align-items:center" am-wear-select>
    <i-row v-if="partCategories.data.length > 0" class="sign-in-row _width:100%" center>
      <i-column xxl="10" xl="10" lg="12">
        <i-tabs v-if="partCategories" v-model="active" stretch>

          <template #header>
            <i-tab-title
              v-for="category in partCategories.data"
              :key="category.id"
              :for="category.code"
              class="_text-transform:uppercase"
            >
              {{ category.name }}
            </i-tab-title>
          </template>

          <i-tab
            v-for="category in partCategories.data"
            :key="category.id"
            :name="category.code"
          >
            <div am-link-block class="_display:flex _justify-content:center">
              <router-link
                v-for="subCategory in category.subCategories"
                :key="subCategory.id"
                :to="
                  `/${lastUrl}/${category.code}/${subCategory.code}/${subCategory.subCategories[0].id}-${subCategory.subCategories[0].code}-${subCategory.id}-${category.id}`
                "
                class="_position:relative _margin:1 _text-decoration:none"
                am-img-link
              >
                <img v-if="imageUrl(category.code)" :src="imageUrl(category.code)" :alt="category.name" />
                <div v-else am-block />
                <div am-hover-block class="_position:absolute _background:black">
                  <p class="_text-transform:uppercase _text:center _font-weight:black _color:white">
                    {{ subCategory.name }}
                  </p>
                </div>
              </router-link>
            </div>
          </i-tab>

        </i-tabs>
      </i-column>
    </i-row>
    <i-loader color="primary" v-else />
  </i-container>
</template>

<script>
import { createNamespacedHelpers, mapState } from 'vuex'
const { mapActions, mapMutations } = createNamespacedHelpers('partCategories')

export default {
  name: 'WearSelect',
  computed: {
    ...mapState(['partCategories']),
    active: {
      get () {
        return this.partCategories.selectedCategory
      },
      set (value) {
        this.setCategory({ code: value })
      }
    },
    lastUrl () {
      if (localStorage.getItem('lastUrl') && localStorage.getItem('lastUrl').includes('instructions')) {
        return 'instructions'
      }
      return 'db'
    }
  },
  methods: {
    ...mapActions(['getPartCategories']),
    ...mapMutations(['setCategory']),
    imageUrl (name) {
      try {
        return require(`../assets/${name}.jpg`)
      } catch (e) {
        return null
      }
    }
  },
  beforeMount () {
    this.getPartCategories()
  }
}
</script>

<style lang="scss">
[am-wear-select] {
  a {
    width: 25%;
    max-width: 130px;
    line-height: 15px;
  }
  img {
    width: 100%;
    height: auto;
  }
  [am-link-block] {
    flex-wrap: nowrap;
  }
  [am-img-link] {
    [am-block] {
      height: 100px;
      background: var(----header--background--hover);
    }
    [am-block] + [am-hover-block] {
      height: 100%;
    }
    [am-hover-block] {
      bottom: 0;
      left: 0;
      width: 100%;
      height: 35%;
      opacity: 1;
      opacity: 0.8;
      background-color: black;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:hover {
      [am-hover-block] {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.5;
        background-color: black;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  [am-wear-select] [am-img-link] {
    [am-hover-block] {
      height: 30%;
    }
  }
}
@media screen and (max-width: 991px) {
  .container[am-wear-select] {
    max-width: 100% !important;
    a {
      font-size: 10px;
    }
  }
}
@media screen and (max-width: 768px) {
  [am-wear-select] {
    [am-img-link] {
      [am-hover-block] {
        height: 45%;
      }
    }
    [am-link-block] {
      flex-wrap: wrap;
    }
  }
}
</style>
